import { Component, Input } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ThemeService } from '../../../services/theme.service';

@Component({
    selector: 'full-screen-loading',
    templateUrl: './full-screen-loading.component.html',
    styleUrls: ['./full-screen-loading.component.scss'],
    animations: [
        trigger('fadeInOut', [
            state('void', style({ opacity: 0 })),
            transition(':enter', [animate('0.5s ease-in')]),
            transition(':leave', [animate('0.5s ease-out')]),
        ]),
    ],
})
export class FullScreenLoadingComponent {
    theme: 'light' | 'dark';
    lottiePath: string = '';
    @Input('text') text = 'loading...';
    constructor(private themeService: ThemeService) {
        this.theme = this.themeService.getTheme();
        this.lottiePath =
            this.theme === 'light' ? 'assets/animations/loading_dark.json' : 'assets/animations/loading.json';
    }
}
